import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Javier M.',
    quote: 'Mi creatinina bajó y el miedo también.',
    text: 'Después de ver mis análisis en 2.1, no podía dormir. Con este protocolo la hinchazón en mis piernas desapareció en 6 días. La guía de hidratación salvó mis riñones.',
    image: 'https://cdn.magicpatterns.com/uploads/xodZ4cwipN2ACEW7a4qgRe/foto1.png'
  }, {
    name: 'Martha S.',
    quote: 'Por fin entiendo cómo cuidar mis riñones.',
    text: 'Lo que más valoro es el recetario. Es tan sencillo que mi familia come lo mismo que yo. Siento mis riñones ligeros y tengo una energía que no tenía hace años.',
    image: 'https://cdn.magicpatterns.com/uploads/5QauQwuXMZqrsJ4WD6MpFg/foto2.png'
  }, {
    name: 'Carlos T.',
    quote: 'Sentí el alivio en mis riñones de inmediato.',
    text: 'Estaba escéptico, pero a los 10 días de seguir el plan, ese sabor extraño en mi boca se fue. Ya no tengo miedo por la salud de mis riñones. ¡Gracias!',
    image: 'https://cdn.magicpatterns.com/uploads/638RXFSGmZxRF7y9pt7iUw/foto3.png'
  }];
  return <section className="py-20 px-6 bg-cream/50" data-id="element-192">
      <div className="max-w-6xl mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-forest" data-id="element-195">
            Historias Reales de Rescate Renal
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-196">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-100 flex flex-col items-center text-center relative pt-14" data-id="element-197">
                <div className="absolute -top-10 w-20 h-20 rounded-full border-4 border-white shadow-md overflow-hidden bg-gray-100" data-id="element-198">
                  <img src={testimonial.image} alt={`Foto de ${testimonial.name}`} className="w-full h-full object-cover" data-id="element-199" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-200">
                  {testimonial.name}
                </h3>
                <p className="text-amber font-medium italic mb-4" data-id="element-201">
                  "{testimonial.quote}"
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-202">
                  {testimonial.text}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}